// "Spot the Slip" expansion — HOUSE & HOME theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_HOUSE = [
  ["La cucina sta molto sporca stamattina.", "La cucina è molto sporca stamattina.", "essere-stare",
    "A changeable condition of a thing uses essere → è sporca.", "essere-vs-stare"],
  ["Il seminterrato sta umido dopo il temporale.", "Il seminterrato è umido dopo il temporale.", "essere-stare",
    "A resulting state uses essere → è umido.", "essere-vs-stare"],
  ["Dove sta il bagno?", "Dov'è il bagno?", "essere-stare",
    "Location of a place uses essere → dov'è.", "essere-vs-stare"],
  ["Il salotto è molto spazioso e luminoso.", "Il salotto è molto spazioso e luminoso.", "essere-stare",
    "Trap check: an inherent feature of the room uses essere. (Already correct!)", "essere-vs-stare"],
  ["Ho un camera piccola.", "Ho una camera piccola.", "gender",
    "Camera is feminine → una camera.", "gender-of-nouns"],
  ["La parete bianco è nuova.", "La parete bianca è nuova.", "agreement",
    "Parete is feminine; the adjective is bianca.", "adjective-agreement"],
  ["Il finestra è aperta.", "La finestra è aperta.", "gender",
    "Finestra is feminine → la finestra.", "gender-of-nouns"],
  ["Mi piace le tende nuove.", "Mi piacciono le tende nuove.", "piacere",
    "Plural curtains → piacciono.", "piacere-and-similar-verbs"],
  ["Le chiavi sono sopra il tavolo, vicino a la porta.", "Le chiavi sono sopra il tavolo, vicino alla porta.", "articulated-prep",
    "a + la contracts to alla.", "preposition-contractions"],
  ["Il gatto dorme sul divano in salotto.", "Il gatto dorme sul divano in salotto.", "articulated-prep",
    "Trap check: su + il = sul. (Already correct!)", "preposition-contractions"],
  ["Le chiavi? Le do a te domani.", "Le chiavi? Te le do domani.", "pronoun-order",
    "Indirect before direct, attached together: te le do.", "object-pronouns"],
  ["Ieri pulivo tutta la casa in due ore.", "Ieri ho pulito tutta la casa in due ore.", "passato-imperfetto",
    "A single, finished action in a set time takes the passato prossimo.", "passato-prossimo-vs-imperfetto"],
  ["Quante camere ci sono? Sono tre.", "Quante camere ci sono? Ce ne sono tre.", "ci-ne",
    "Use ci + ne for a quantity present → ce ne sono tre.", "ci-and-ne"],
  ["È importante che la casa ha un buon riscaldamento.", "È importante che la casa abbia un buon riscaldamento.", "congiuntivo",
    "Impersonal 'è importante che' takes the subjunctive → abbia.", "congiuntivo-presente"],
  ["Cerco un appartamento che è spazioso e economico.", "Cerco un appartamento che sia spazioso ed economico.", "congiuntivo",
    "An as-yet-unknown thing you're searching for triggers the subjunctive → sia.", "congiuntivo-presente"],
];
